module.exports = "img/2.83e37b.webp";